import React, {useState} from 'react';
import BarraSecundaria from '../Components/BarraSecundaria';
import '../Styles/productos.css';
import {Container,Row,Col} from 'react-bootstrap';
import ProductosRelacionados from '../Components/ProductosRelacionados'
import ProductosLista from '../Components/ProductosLista'; 


  const Productos = ({titulo}) => {

  const micategoria = `${titulo}`
  
  const micategoriaLow = micategoria.toLowerCase();
  
    return (
    <>
      
      <Container fluid="100%" id="inicio">
        <Row>
          <Col>
            <div className="portadaPrincipal">
              <div className="logoPrincipal2">
                <img alt="logoGrande" className="logoGrande" src="./img/milaLogo.png"/>
                {/* para que funciona la opcion de que se muestre el fondo correspondiente
                a la categoria, tengo que ver la manera de poder hacer una condicional en html o en css o js
                en funcion al parametro titulo para que en base a eso se muestre un
                background-image: dependiendo a las imagenes que ya deberian estar
                subidas en el storage de las portadas de las categorias. */}
              </div>        
            </div>
          </Col>
          <Col>
            <div 
              className='portada_prod_img'
              // style={{backgroundImage: "url(iamagen)"}}
            >
              <h1>{titulo}</h1>
            </div>
          </Col>
        </Row>
      </Container>

      <BarraSecundaria />
      <div id="productos_categoria">
        <ProductosLista  query_data={micategoriaLow}/>
      </div>  
      
      <h1>Nuevos Productos: </h1>
      {/* <ProductosRelacionados titulo="Flores"/>
      <ProductosRelacionados titulo="Manteleria"/> */}
      <div>
        {
          {
            'Alabastro':
              <>
                <ProductosRelacionados titulo="Manteleria" query_data="manteleria"/>
                <ProductosRelacionados titulo="Murano" query_data="murano"/>
              </>,  
            'Cristal':
              <>
                <ProductosRelacionados titulo="Flores" query_data="flores"/>
                <ProductosRelacionados titulo="Mantelería" query_data="manteleria"/>
              </>,
            'Flores':
              <>
                <ProductosRelacionados titulo="Cristal" query_data="cristal"/>
                <ProductosRelacionados titulo="Vidrio" query_data="vidrio"/>
              </>,
            'Manteleria':
              <>
                <ProductosRelacionados titulo="Cristal" query_data="cristal"/>
                <ProductosRelacionados titulo="Alabastro" query_data="alabastro"/>
              </>,
            'Murano':
              <>
                <ProductosRelacionados titulo="Manteleria" query_data="manteleria"/>
                <ProductosRelacionados titulo="Religion" query_data="plaque"/>
              </>,
            'Navidad':
              <>
                <ProductosRelacionados titulo="Poliresina" query_data="poliresina"/>
                <ProductosRelacionados titulo="Manteleria" query_data="manteleria"/>
              </>,
            'Religion':
              <>
                <ProductosRelacionados titulo="Poliresina" query_data="poliresina"/>
                <ProductosRelacionados titulo="Porcelana" query_data="porcelana"/>
              </>,
            'Poliresina':
              <>
                <ProductosRelacionados titulo="Manteleria" query_data="manteleria"/>
                <ProductosRelacionados titulo="Religion" query_data="plaque"/>
              </>,
            'Porcelana':
              <>
                <ProductosRelacionados titulo="Cristal" query_data="cristal"/>
                <ProductosRelacionados titulo="Vidrio" query_data="vidrio"/>
              </>,
            'Vidrio':
              <>
                <ProductosRelacionados titulo="Cristales" query_data="cristal"/>
                <ProductosRelacionados titulo="Flores" query_data="flores"/>
              </>
          }[micategoria]

        }
      </div>
      
    </>
    
  )
}

export default Productos